export var NodeStatuses;
(function (NodeStatuses) {
    NodeStatuses["locked"] = "locked";
    NodeStatuses["unexplored"] = "unexplored";
    NodeStatuses["seen"] = "seen";
    NodeStatuses["alerted"] = "alerted";
})(NodeStatuses || (NodeStatuses = {}));
